<template>
    <div class="mcontainer">
        <div class="d-flex justify-content-between align-items-center mb-4">
            <div class="breadcrumb-area py-0">
                <div class="breadcrumb">
                    <ul class="m-0">
                        <li>
                            <router-link to="/app/group">Groups</router-link>
                        </li>
                        <li class="active">
                            <a href="#">Categories </a>
                        </li>
                    </ul>
                </div>
            </div>

            <router-link :to="{ name: 'CategoryGroupCreate' }" class="flex items-center justify-center h-9 lg:px-5 rounded-md bg-blue-600 text-white space-x-1.5">
                <Icon icon="uiw:plus" />
                <span class="md:block hidden"> Add Category</span>
            </router-link>
        </div>
        <div>
            <b-row v-if="data.length > 0" class="flex flex-wrap">
                <b-col sm="3" v-for="item in data" :key="item.id">
                    <div class="card group-category mb-4">
                        <img :src="item.images ? item.images : $placeholder2" class="preview-topics">
                        <div class="topic-item-card">
                            <p class="m-0">{{ item.title }}</p>
                            <div class="group-button-topic">
                                <a target="_blank">
                                    <b-button variant="link" :to="{ name: 'CategoryGroupEdit', params: { id: item.id} }" size="sm" class="btn-edit text-secondary mr-2">
                                        <Icon icon="akar-icons:edit" class="d-inline" />
                                    </b-button>
                                </a>
                                <b-button variant="link" size="sm" class="btn-delete" @click="deleteItem(item.id)">
                                    <Icon icon="bi:trash" class="d-inline" />
                                </b-button>
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex'
    import { Icon } from '@iconify/vue2'
    export default {
        components: { Icon },
        computed: mapState('groupCategories', ['loading', 'data']),
        methods: {
            ...mapActions('groupCategories', ['get', 'delete']),
            deleteItem (id) {
                this.$swal({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.delete(id).then(() => {
                            this.$swal(
                                'Deleted!',
                                'Category has been deleted.',
                                'success'
                            )

                            this.get()
                        })
                    }
                })
            }
        },
        created () {
            this.get()
        }
    }
</script>
